"use strict";
exports.__esModule = true;
exports.isLastName = exports.isFirstName = void 0;
var latinCharsDashSpacePattern = '^[a-z\\-\\s]+$';
var latinCharsDashAposSpacePattern = "^[a-z'\\-\\s]+$";
var validFirstNameExpression = new RegExp(latinCharsDashSpacePattern, 'gi');
var validLastNameExpression = new RegExp(latinCharsDashAposSpacePattern, 'gi');
function isFirstName(value) {
    return value.match(validFirstNameExpression) !== null;
}
exports.isFirstName = isFirstName;
function isLastName(value) {
    return value.match(validLastNameExpression) !== null;
}
exports.isLastName = isLastName;
//# sourceMappingURL=name.js.map